import { K365SubscriptionsState } from '@layout/k365-subscriptions/store/state/k365-subscriptions.state';

export const k365SubscriptionsState = [K365SubscriptionsState];
